import { render } from "./GlobalSearchView.vue?vue&type=template&id=d780cb32"
import script from "./GlobalSearchView.vue?vue&type=script&lang=js"
export * from "./GlobalSearchView.vue?vue&type=script&lang=js"

import "./GlobalSearchView.vue?vue&type=style&index=0&id=d780cb32&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__